import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  confirmContainer: {
    background: "#fff",
    display: "flex",
    width: "575px",
    boxSizing: "border-box",
    flexDirection: "column",
    padding: 24,
    color: "#666",
    gap: "24px",
    minHeight: "229px",
    border: "1px solid #CCCCCC",
    borderRadius: "4px",
    "& h5": {
      padding: 0,
      color: "#666",
      fontSize: "1rem",
    },
  },
  title: {
    marginTop: "2rem",
    fontSize: "14px",
    textAlign: "center",
    "& h4": {
      fontSize: "20px",
      fontWeight: 700,
    },
  },
  infoText: {
    fontSize: "14px",
    padding: "16px",
    background: "#F4F4F4",
    textAlign: "center",
  },
  alignCenterContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mailIcon: {
    border: "3px solid #26975A",
    width: "64px",
    height: "64px",
    borderRadius: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#26975A",
    "& svg": {
      fontSize: "30px",
    },
  },
  questions: {
    fontSize: "14px",
    textAlign: 'center',
    '& a': {
      color: '#007582'
    }
  },
  confirmBtn: {
    width: "104px",
    height: "32px",
    textTransform: "none",
    background: '#26975A'
  },
}));

export default useStyles;
